/**
 * Filters for configuration table
 */
export var ConfigurationTableFilterOperator;
(function (ConfigurationTableFilterOperator) {
    ConfigurationTableFilterOperator["Contains"] = "Contains";
    ConfigurationTableFilterOperator["Equals"] = "Equals";
    ConfigurationTableFilterOperator["Range"] = "Range";
})(ConfigurationTableFilterOperator || (ConfigurationTableFilterOperator = {}));
//# sourceMappingURL=ConfigurationTableFilterOperator.js.map